import React from 'react'
import OrderDetails from '../../../component/order/OrderDetails'

const OrderDetailPage = () => {
    return (
        <div style={{margin : "20px"}}>
            <OrderDetails />
        </div>
    )
}

export default OrderDetailPage